import { render, staticRenderFns } from "./HomeNewsListSec.vue?vue&type=template&id=0cf29d70&"
import script from "./HomeNewsListSec.vue?vue&type=script&lang=js&"
export * from "./HomeNewsListSec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports